var App = App || {};
(function () {

	if (App.page) return;

	App.page = {

		MAX_FILES: 10,
		MAX_SIZE: 20 * 1024 * 1024,
		_uploading: 0,
		_sending: false,
		emailRe: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,

		CLOSE_SVG: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.1528 4.8464C11.3481 5.04166 11.3481 5.35824 11.1528 5.5535L8.70633 7.99998L11.1528 10.4464C11.348 10.6417 11.348 10.9583 11.1528 11.1535C10.9575 11.3488 10.6409 11.3488 10.4457 11.1535L7.99922 8.70708L5.5528 11.1535C5.35753 11.3488 5.04095 11.3488 4.84569 11.1535C4.65043 10.9582 4.65043 10.6417 4.84569 10.4464L7.29211 7.99998L4.84567 5.55353C4.6504 5.35827 4.6504 5.04168 4.84567 4.84642C5.04093 4.65116 5.35751 4.65116 5.55277 4.84642L7.99922 7.29287L10.4457 4.8464C10.641 4.65114 10.9575 4.65114 11.1528 4.8464Z" fill="white"/></svg>',

		THUMB_FILE_SVG: '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.625 0C1.17525 0 0 1.17525 0 2.625V11.625C0 13.0747 1.17525 14.25 2.625 14.25H9.625C11.0747 14.25 12.25 13.0747 12.25 11.625V4.95343C12.25 4.25723 11.9734 3.58955 11.4812 3.09727L9.15273 0.768844C8.66044 0.276561 7.99277 0 7.29657 0H2.625ZM1.25 2.625C1.25 1.86561 1.86561 1.25 2.625 1.25H6.625C7.10825 1.25 7.5 1.64175 7.5 2.125V3.75C7.5 4.30228 7.94772 4.75 8.5 4.75H10.125C10.6082 4.75 11 5.14175 11 5.625V11.625C11 12.3844 10.3844 13 9.625 13H2.625C1.86561 13 1.25 12.3844 1.25 11.625V2.625Z" fill="black" fill-opacity="0.66"/></svg>',

		THUMB_ERR_SVG: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 6C9.46459 6 9.04623 6.46228 9.0995 6.99504L9.45025 10.5025C9.47849 10.7849 9.71616 11 10 11C10.2838 11 10.5215 10.7849 10.5498 10.5025L10.9005 6.99504C10.9538 6.46228 10.5354 6 10 6Z" fill="#E34F5E"/><path d="M10 14C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12C9.44771 12 9 12.4477 9 13C9 13.5523 9.44771 14 10 14Z" fill="#E34F5E"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.68958 1.76128L1.21221 14.6728C0.616034 15.7022 1.34679 17 2.52264 17H17.4774C18.6532 17 19.384 15.7022 18.7878 14.6728L11.3104 1.76128C10.7226 0.746239 9.27741 0.746239 8.68958 1.76128ZM2.30423 15.3253L9.7816 2.41375C9.87957 2.24458 10.1204 2.24458 10.2184 2.41375L17.6958 15.3253C17.7951 15.4968 17.6733 15.7131 17.4774 15.7131H2.52264C2.32666 15.7131 2.20487 15.4968 2.30423 15.3253Z" fill="#E34F5E"/></svg>',

		injectHoneypot: function (form) {
			if (form.chkfrm) return;
			var v = 'ws_' + 'c' + 'h' + (4 * 5 - 1 * 2) + 1 + 'eck';
			$(form).append('<input type="hidden" name="chkfrm" value="' + v + '">'
				+ '<input type="hidden" name="chkfrm2" value="">');
		},

		bindTypes: function () {
			$('#supportType').on('click', 'button', function () {
				$('#supportType button').removeClass('btn-semi-active');
				$(this).addClass('btn-semi-active');
				$('input[name=id_type]').val($(this).val());
				$('#supportType').removeClass('is-error');
			});
		},


		attachCount: function () {
			return $('#supportAttach .support__attach__item').not('.support__attach__item-err').length;
		},

		closeBtn: function () {
			return '<button type="button" class="btn btn-32 btn-primary btn-square btn-close"><ws-icon>' + this.CLOSE_SVG + '</ws-icon></button>';
		},

		formatSize: function (bytes) {
			if (bytes >= 1024 * 1024) return (bytes / 1024 / 1024).toFixed(1).replace(/\.0$/, '') + ' MB';
			if (bytes >= 1024) return Math.round(bytes / 1024) + ' KB';
			return bytes + ' B';
		},

		renderPreview: function (file) {
			var isImg = /^image\//.test(file.type);
			var thumb, cls = '';
			if (isImg) {
				thumb = '<img width="80" height="56">';
			} else {
				thumb = '<ws-icon>' + this.THUMB_FILE_SVG + '</ws-icon>';
				cls = ' support__attach__item-noprev';
			}
			var $item = $(
				'<div class="support__attach__item' + cls + '">' +
					'<div class="support__attach__item-thumb">' + thumb + '</div>' +
					'<div class="support__attach__item-fname"></div>' +
					'<div class="support__attach__item-fsize">' + this.formatSize(file.size) + '</div>' +
					this.closeBtn() +
				'</div>'
			);
			$item.find('.support__attach__item-fname').text(file.name);
			if (isImg) {
				var url = URL.createObjectURL(file);
				$item.find('img').attr('src', url);
				$item.data('objurl', url);
			}
			return $item;
		},

		markError: function ($item, file, reason) {
			var url = $item.data('objurl');
			if (url) { try { URL.revokeObjectURL(url); } catch (e) {} $item.removeData('objurl'); }
			$item.attr('class', 'support__attach__item support__attach__item-err')
				.removeClass('is-loading')
				.empty()
				.append(
					'<div class="support__attach__item-thumb"><ws-icon>' + this.THUMB_ERR_SVG + '</ws-icon></div>' +
					'<div class="support__attach__item-fname"></div>' +
					'<div class="support__attach__item-fsize"></div>' +
					this.closeBtn()
				);
			$item.find('.support__attach__item-fname').text(file.name);
			$item.find('.support__attach__item-fsize').text(reason || '');
		},

		uploadErrorMsg: function () {
			return $('.support__form').attr('data-upload-error') || '';
		},

		removeItem: function ($item) {
			var url = $item.data('objurl');
			if (url) { try { URL.revokeObjectURL(url); } catch (e) {} }
			$item.remove();
			if (this.attachCount() < this.MAX_FILES) $('#supportTooMany').prop('hidden', true);
		},

		addFiles: function (form, files) {
			var self = this, skipped = false;
			Array.prototype.forEach.call(files, function (f) {
				if (self.attachCount() >= self.MAX_FILES) { skipped = true; return; }
				self.uploadFile(form, f);
			});
			$('#supportTooMany').prop('hidden', !skipped);
			if (skipped) {
				var $a = $('.js-support-attach');
				if ($a.blink) $a.blink();
			}
		},

		uploadFile: function (form, file) {
			var self = this;
			var $item = this.renderPreview(file).appendTo('#supportAttach');

			if (file.size > this.MAX_SIZE) {
				this.markError($item, file, $(form).attr('data-err-toobig') || '');
				return;
			}
			$item.addClass('is-loading');
			$('<div class="support__attach__item-progress"></div>').appendTo($item.find('.support__attach__item-thumb'));

			var fd = new FormData();
			fd.append('action', 'upload');
			fd.append('ufile[]', file);

			self._uploading++;
			$('.support__form__contact-submit ws-btn').attr('data-title', $(form).attr('data-uploading-hint') || '');
			$.ajax({
				url: form.getAttribute('action'),
				type: 'POST',
				data: fd,
				processData: false,
				contentType: false,
				dataType: 'json',
				headers: { 'x-load-type': 'ajax' },
				xhr: function () {
					var xhr = $.ajaxSettings.xhr();
					if (xhr.upload) {
						xhr.upload.addEventListener('progress', function (e) {
							if (e.lengthComputable) {
								var pc = Math.round(e.loaded / e.total * 100);
								$item.find('.support__attach__item-fsize').text(pc + '%');
								$item.find('.support__attach__item-progress').css('width', (100 - pc) + '%');
							}
						});
					}
					return xhr;
				},
				success: function (resp) {
					if (resp && resp.status === 'ok') {
						$item.append($('<input type="hidden" name="ufile_[name][]">').val(resp.name))
							 .append($('<input type="hidden" name="ufile_[file][]">').val(resp.file))
							 .removeClass('is-loading');
						$item.find('.support__attach__item-progress').remove();
						$item.find('.support__attach__item-fsize').text(self.formatSize(file.size));
					} else {
						self.markError($item, file, (resp && resp.reason) || self.uploadErrorMsg());
					}
				},
				error: function () { self.markError($item, file, self.uploadErrorMsg()); },
				complete: function () {
					if (--self._uploading <= 0) {
						$('.support__form__contact-submit ws-btn').removeAttr('data-title');
					}
				}
			});
		},

		bindUpload: function (form) {
			var self = this;
			var $file = $(form).find('input[type=file][name="ufile[]"]');

			$('.js-support-attach').on('click', function () { $file.trigger('click'); });

			$file.on('change', function () {
				self.addFiles(form, this.files || []);
				$(this).val('');
			});

			$('#supportAttach').on('click', '.btn-close', function () {
				self.removeItem($(this).closest('.support__attach__item'));
			});
		},

		bindDrag: function (form) {
			var self = this, depth = 0;
			var hasFiles = function (e) {
				var dt = e.originalEvent && e.originalEvent.dataTransfer;
				return dt && dt.types && Array.prototype.indexOf.call(dt.types, 'Files') !== -1;
			};
			$(document)
				.on('dragenter', function (e) {
					if (!hasFiles(e)) return;
					e.preventDefault();
					depth++;
					$('body').addClass('body_drop');
				})
				.on('dragover', function (e) {
					if (!hasFiles(e)) return;
					e.preventDefault();
				})
				.on('dragleave', function (e) {
					if (!hasFiles(e)) return;
					if (--depth <= 0) { depth = 0; $('body').removeClass('body_drop'); }
				})
				.on('drop', function (e) {
					depth = 0;
					$('body').removeClass('body_drop');
					if (hasFiles(e)) e.preventDefault();
				});

			$(form).find('.support__drop__zone')
				.on('dragenter dragover', function (e) { e.preventDefault(); $(this).addClass('is-dragover'); })
				.on('dragleave', function () { $(this).removeClass('is-dragover'); })
				.on('drop', function (e) {
					e.preventDefault();
					e.stopPropagation();
					depth = 0;
					$(this).removeClass('is-dragover');
					$('body').removeClass('body_drop');
					var dt = e.originalEvent && e.originalEvent.dataTransfer;
					if (dt && dt.files && dt.files.length) self.addFiles(form, dt.files);
				});
		},

		bindLogin: function () {
			var $login = $('.support__form__login');
			if (!$login.length) return;

			$login.on('click', '.btn-close', function () {
				$login.css('display', 'none');
			});

			$login.on('click', '.support__form__login-button button', function () {
				if (App.auth && App.auth.show) App.auth.show('login');
			});
		},


		// підсвічуємо лише першу помилку згори вниз, а не всі одразу
		check: function (form) {
			$('#supportType').removeClass('is-error');
			$(form).find('.req').removeClass('is-error')
				.closest('.support__form__contact-row').removeClass('is-error');
			$(form).find('.support__form__contact-checkbox').removeClass('is-error');

			var found = false;

			if (!$('input[name=id_type]').val()) {
				$('#supportType').addClass('is-error');
				found = true;
			}

			if (!found) {
				$(form).find('.req').each(function () {
					var $f = $(this);
					var val = $.trim($f.val());
					if (!val || ($f.attr('type') === 'email' && !App.page.emailRe.test(val))) {
						$f.addClass('is-error');
						$f.closest('.support__form__contact-row').addClass('is-error');
						found = true;
						return false;
					}
				});
			}

			if (!found) {
				var $agree = $(form).find('#agree');
				if ($agree.length && !$agree.prop('checked')) {
					$agree.closest('.support__form__contact-checkbox').addClass('is-error');
					found = true;
				}
			}

			return !found;
		},

		// повертаємо користувача до першої помилки: на мобілці тап по кнопці
		// перебиває нативний scrollIntoView, тому скролимо анімацією вручну
		scrollToError: function (form) {
			var $bad = $(form).find('.is-error').first();
			if (!$bad.length) return;
			if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
			setTimeout(function () {
				var top = $bad.offset().top - Math.max((window.innerHeight - $bad.outerHeight()) / 2, 20);
				$('html, body').stop().animate({ scrollTop: Math.max(top, 0) }, 300);
			}, 30);
		},

		send: function (form) {
			if (this._sending) return;
			if (this._uploading > 0) {
				var $a = $('.js-support-attach');
				if ($a.blink) $a.blink();
				return;
			}

			if (!this.check(form)) {
				this.scrollToError(form);
				return;
			}

			if (form.chkfrm2) form.chkfrm2.value = 'ok';

			var payload = $(form).serialize() + '&action=send';
			if (typeof md5 === 'function' && form.email) {
				payload += '&hash=' + md5(document.location.host + form.email.value);
			}

			var self = this;
			this._sending = true;
			$('.support__form__contact-submit ws-btn').addClass('btn-loading');
			$.ajax({
				type: 'POST',
				url: form.getAttribute('action'),
				data: payload,
				dataType: 'script',
				complete: function () {
					self._sending = false;
					$('.support__form__contact-submit ws-btn').removeClass('btn-loading');
				}
			});
		},

		bind: function () {
			var form = document.querySelector('.support__form');
			if (!form) return;

			this.injectHoneypot(form);
			this.bindTypes();
			this.bindUpload(form);
			this.bindDrag(form);
			this.bindLogin();

			$(form).find('#agree').on('change', function () {
				if (this.checked) $(this).closest('.support__form__contact-checkbox').removeClass('is-error');
			});

			$(form).find('.req').on('input', function () {
				$(this).removeClass('is-error');
				$(this).closest('.support__form__contact-row').removeClass('is-error');
			});

			$(document).on('click', '.support__form__contact-submit ws-btn', function () {
				App.page.send(form);
			});

			$(document).on('click', '.js-support-again', function () {
				$('#supportAttach .support__attach__item').each(function () {
					App.page.removeItem($(this));
				});
				$('#name, #descr').val('');
				$('#supportType button').removeClass('btn-semi-active');
				$('input[name=id_type]').val('');
				$('#agree').prop('checked', false);
				$('#supportComplete').hide();
				$('#supportForm').show();
				window.scrollTo(0, 0);
			});
		},

		onload: function () {
			this.bind();
		}
	};

})();
$(function () {
	App.page.onload();
});
